import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authApi } from "@services/contentApi";

export default function ProtectedAdmin({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ loading: true, user: null });

  useEffect(() => {
    authApi.me()
      .then(({ user }) => setState({ loading: false, user }))
      .catch(() => setState({ loading: false, user: null }));
  }, []);

  if (state.loading) return <main className="auth-page"><span className="auth-status">Проверяем сессию…</span></main>;
  if (!state.user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (state.user.role !== "admin") return <Navigate to="/login" replace />;
  return children;
}
